import React, { Component, useEffect, useState, useRef } from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import TruckIcon from './driver-truck.png'
import { compose } from 'redux'
import { connect } from 'react-redux'
import originPin from '../../Map/origin-selected-pin.svg'
import destPin from '../../Map/destination-selected-pin.svg'
import makeStyles from '@material-ui/core/styles/makeStyles'
import { getOrderStateId } from '../../../../actions/actionCreators'
import { Box } from '@material-ui/core'

import NeshanMap from 'react-neshan-map-leaflet'

/**
 * JSS.
 * @param theme
 * @returns {{mapStyle: {width: string, height: string}}}
 */
const useStyles = makeStyles((theme) => ({
	mapContainer: {
		height: '15rem',
		width: '100%',
		overflow: 'hidden',
	},
	mapStyle: {
		width: '100% !important',
		height: '15rem !important',
	},
}))

/**
 * Map redux states.
 * @param state
 * @returns {{}}
 */
const mapStateToProps = (state) => ({ ...state.invoice, ...state.order.map })

/**
 * Create the Map object from map.ir
 */
// const Map = Mapir.setToken({
// 	transformRequest: (url) => {
// 		return {
// 			url: url,
// 			headers: {
// 				// "x-api-key": process.env.REACT_APP_MAPIR_API_KEY,
// 				'x-api-key':
// 					'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImJlODA1NDJiZmU2ODdjZWYyM2U3M2IzYjZkYzM3ZjViMmVhMTUyZTJlZjdjMmNmYmZlNDFmOGE1ODkyNGZmMjBmM2M4YTQ1ZGNhOGU4ZGZkIn0.eyJhdWQiOiIxNjA3MCIsImp0aSI6ImJlODA1NDJiZmU2ODdjZWYyM2U3M2IzYjZkYzM3ZjViMmVhMTUyZTJlZjdjMmNmYmZlNDFmOGE1ODkyNGZmMjBmM2M4YTQ1ZGNhOGU4ZGZkIiwiaWF0IjoxNjM2OTcyNTY0LCJuYmYiOjE2MzY5NzI1NjQsImV4cCI6MTYzOTQ3ODE2NCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.o26dFrwtrZsfqK6IDhTXFOEh3au30e11II45RILpeRMpS5K8T6Q_nla7MnpZnxDNXiliGqHd5E2OWMCGdfIc5OfbB8GZUtW0zxU-pQP-wbvedZ1xmUfyq_yMw3XbsWDvQlXwcDRy2ouT6f2riUIz_zyxJ4lFki2PxLj2A-wAnxDqNS7SA7co-dwn9WRd_4uNROAhvQk7lCd-5nQJVL31UljiKVoRiy819T-V2S4HEuZBfixUto-pXA6Q53e4-YaRXmrM9p0ZSm-cfhX8Pwis4MucjrxjD6qvQv19aJ2HA6NzG1gYgcm0yeFZ5m9kCbg1P6XrRxU13-G8diLI_Vyn5w',
// 				'Mapir-SDK': 'reactjs',
// 			},
// 		}
// 	},
// })

/**
 * Track Driver Component: shows the driver location if available,
 * otherwise it will show the origin location when order operation
 * has not begun and destination location when operation is done.
 */
const TrackDriver = (props) => {
	const classes = useStyles()

	const {
		center,
		driverLocation,
		bill: { status, destination = {}, origin = {} } = {},
	} = ({} = props)

	const mapRef = useRef()
	const leaflet = useRef()

	const driverM = useRef()
	const originM = useRef()
	const destM = useRef()

	// useEffect(() => {
	// 	if (driverLocation) setMapCenter([driverLocation.lng, driverLocation.lat])
	// 	else if (origin.lat)
	// 		if (status < getOrderStateId('started'))
	// 			return setMapCenter([origin.long, origin.lat])
	// 		else return setMapCenter([destination.long, destination.lat])
	// }, [driverLocation, origin.lat, destination.lat, status])

	useEffect(() => {
		if (leaflet.current && mapRef.current) {
			if (origin.long && origin.lat) {
				originM.current = leaflet.current
					.marker([origin.lat, origin.long], {
						icon: leaflet.current.icon({
							iconUrl: originPin.toString(),
							iconSize: [60, 140],
							iconAnchor: [30, 70],
						}),
					})
					.addTo(mapRef.current)
			}
			if (destination.long && destination.lat) {
				destM.current = leaflet.current
					.marker([destination.lat, destination.long], {
						icon: leaflet.current.icon({
							iconUrl: destPin.toString(),
							iconSize: [60, 140],
							iconAnchor: [30, 70],
						}),
					})
					.addTo(mapRef.current)
			}
			if (driverLocation) {
				driverM.current = leaflet.current
					.marker([driverLocation.lat, driverLocation.long], {
						icon: leaflet.current.icon({
							iconUrl: TruckIcon.toString(),
							iconSize: [60, 140],
							iconAnchor: [30, 70],
						}),
					})
					.addTo(mapRef.current)
			}
			if (driverM.current && destM.current && originM.current) {
				let group = new leaflet.current.featureGroup([
					driverM.current,
					destM.current,
					originM.current,
				])
				mapRef.current.fitBounds(group.getBounds())
			} else if (destM.current && originM.current) {
				let group = new leaflet.current.featureGroup([
					destM.current,
					originM.current,
				])
				mapRef.current.fitBounds(group.getBounds())
			}
		}
	}, [driverLocation, origin, destination])

	return (
		<Box className={classes.mapContainer}>
			<NeshanMap
				onInit={(L, myMap) => {
					myMap.setMapType('neshan')
					mapRef.current = myMap
					leaflet.current = L
				}}
				options={{
					key: 'web.s84rqwe3QiNdbVy9XlnkJSAjxTVLjbr4RCSAl6Fa',
					zoom: 13,
					minZoom: 4,
					maxZoom: 19,
					zoomControl: false,
				}}
				style={{
					height: '100%',
					width: '100%',
				}}
			/>
		</Box>
	)
}

export default compose(connect(mapStateToProps))(TrackDriver)

{
	/* <Mapir
				className={classes.mapStyle}
				center={mapCenter}
				zoom={[16]}
				// boxSelect={false}
				fitBounds={[
					[origin.long, origin.lat],
					[destination.long, destination.lat],
				]}
				Map={Map}>
				<Mapir.Layer
					type='symbol'
					layout={{ 'icon-image': 'harbor-15' }}></Mapir.Layer>

				{driverLocation && (
					<Mapir.Marker
						coordinates={[driverLocation.lng, driverLocation.lat]}
						Image={TruckIcon}
						anchor='bottom'></Mapir.Marker>
				)}

				<Mapir.Marker coordinates={[origin.long, origin.lat]} anchor='bottom' />

				{origin.long && (
					<Mapir.Marker
						coordinates={[origin.long, origin.lat]}
						Image={originPin}
						anchor='bottom'></Mapir.Marker>
				)}

				{destination.long && (
					<Mapir.Marker
						coordinates={[destination.long, destination.lat]}
						Image={destPin}
						anchor='bottom'></Mapir.Marker>
				)}
			</Mapir> */
}
